<template>
  <div class="w-100">
    <div v-if="!initialized" class="loading-wrapper">
      <proa-loading class="loading"/>
    </div>
    <proa-heading v-else-if="httpError">{{ $t('pages.guestMeeting.invalidTokenMessage') }}</proa-heading>
    <proa-modal
      :modal="signOutRequiredModal"
      :title="$t('common.confirm')"
      noCloseOnBackdrop
      @close="onCloseSignOutRequiredModal"
    >
      <div class="text-pre-wrap">{{ $t('pages.guestMeeting.signOutRequiredMessage') }}</div>
      <template slot="footer">
        <proa-button
          @click.native="onCloseSignOutRequiredModal"
          class="mr-2"
        >
          {{ $t('common.cancel') }}
        </proa-button>
        <proa-button
          @click.native="onClickSignOut"
          :loading="httpRequesting"
          variant="primary"
        >
          {{ $t('common.enterMeetingRoom') }}
        </proa-button>
      </template>
    </proa-modal>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'

export default {
  name: 'GuestMeeting',
  computed: {
    guestToken: function() { return this.$route.query.token },
    ...mapGetters({
      httpError: 'httpError',
      httpRequesting: 'httpRequesting',
      signedInUser: 'auth/signedInUser'
    })
  },
  data() {
    return {
      initialized: false,
      signOutRequiredModal: false
    }
  },
  methods: {
    onCloseSignOutRequiredModal: function() {
      if (this.httpRequesting) return
      this.$router.push({ name: 'mySpace' })
    },
    async onClickSignOut() {
      await this.signOut(true)
      location.reload()
    },
    ...mapActions({
      signOut: 'auth/signOut',
      validateGuestToken: 'inviteAuth/validateGuestToken'
    })
  },
  async created() {
    if (this.signedInUser) {
      this.signOutRequiredModal = this.initialized = true
      return
    } else {
      await this.validateGuestToken(this.guestToken)
    }
    this.initialized = true

    if (!this.httpError) {
      this.$router.push({
        name: 'guestMeetingRoom',
        query: {
          token: this.guestToken
        }
      })
    }
  }
}
</script>

<style scoped lang="scss">
.loading-wrapper {
  display: flex;
  align-items: center;
  justify-content: center;
  padding-top: 40px;

  .loading {
    width: 80px;
    height: 80px;
  }
}
</style>
